import { render, staticRenderFns } from "./CourseShow.vue?vue&type=template&id=5d83a27f&scoped=true"
import script from "./CourseShow.vue?vue&type=script&lang=js"
export * from "./CourseShow.vue?vue&type=script&lang=js"
import style0 from "./CourseShow.vue?vue&type=style&index=0&id=5d83a27f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d83a27f",
  null
  
)

export default component.exports